import { getRgObjectsOfType as G, RG_TYPE as P, RgCreate as b, DefaultGlazing as k } from "@project-rouge/rg-core";
import { Line3 as x, Vector3 as r } from "three";
import { applyInverseTransform as q } from "../../geometry-utils/core/index.js";
import { applyTransform as Y } from "../../geometry-utils/core/index2.js";
import { doLinesOverlap as H } from "../../geometry-utils/core/index6.js";
import { getLinesFromPolygon as W } from "../../geometry-utils/core/index9.js";
import { getLocalCorners as J } from "../../geometry-utils/core/index10.js";
import { getOverlapLine as K } from "../../geometry-utils/core/index12.js";
import { getOverlappingLinesBetweenSets as N } from "../../geometry-utils/core/index13.js";
import { isPointInside as Q } from "../../geometry-utils/core/index19.js";
import { LineV3toLine3 as A } from "../../geometry-utils/index2.js";
import { getPivot as O } from "../../geometry-utils/three/index12.js";
import { Vector3toV3 as j } from "../../geometry-utils/index10.js";
const M = 0.8, E = 5, F = 2;
function pe(n) {
  const l = {
    ground: {
      width: 0.7,
      height: 0.8
    },
    above: {
      width: 0.7,
      height: 0.8
    }
  }, a = n.data.levels.filter((e) => e.isPodium);
  if (a.length < 0)
    return;
  const c = n.data.levels.sort((e, o) => e.levelIndex - o.levelIndex).filter((e) => !e.isPodium)[0], p = G(n, P.EmptySpace), L = p.map((e) => e.data.polygon.map((o) => [o[0] + e.pos[0], 0, o[2] + e.pos[2]])), m = G(n, P.Facade), w = n.children.filter((e) => e.type === P.Apartment && e.data.level === c.levelIndex), s = [];
  for (const e of w) {
    const o = G(e, P.Module);
    for (const d of o) {
      const z = j(Y(O([0.5, 0, 0.5], d), e));
      if (z[1] = 0, L.some((f) => Q(z, f))) {
        const f = J(d).map((t) => j(Y(t, e))).map((t) => [t[0], 0, t[2]]), g = W(f);
        s.push(...g.map(A));
      }
    }
  }
  for (const e of a) {
    const o = e.levelIndex === 0 ? l.ground : l.above, d = [];
    for (let t = 0; t < p.length; t++)
      if (p[t].data.level === e.levelIndex) {
        const h = L[t];
        d.push(...W(h));
      }
    const z = N(s, d), f = m.filter((t) => t.data.level === e.levelIndex), g = [];
    for (const t of f) {
      if (t.size[0] < F)
        continue;
      const i = new x(O([0, 0, 1], t), O([1, 0, 1], t)), h = i.start.y;
      i.start.setY(0), i.end.setY(0);
      const S = z.filter((u) => H(i, u));
      if (S.length > 0)
        for (const u of S) {
          const v = K(u, i), B = v.distance(), y = Math.min(t.size[0], B) * o.width;
          if (y < F)
            continue;
          const C = v.getCenter(new r());
          C.y = h;
          const R = v.delta(new r()).normalize(), T = new x(
            C.clone().add(R.clone().multiplyScalar(-y / 2)),
            C.clone().add(R.clone().multiplyScalar(y / 2))
          );
          if (y > E) {
            const I = U(T);
            for (const V of I) {
              const D = V.distance(), _ = V.getCenter(new r()).toArray();
              g.push({ facade: t, width: D, mid: _ });
            }
          } else {
            const I = T.getCenter(new r()).toArray();
            g.push({ facade: t, width: y, mid: I });
          }
        }
    }
    for (const { facade: t, width: i, mid: h } of g) {
      const S = t.size[1] * o.height, u = q(h, t), v = b({
        ...k,
        name: "glazing element",
        size: [i, S, t.size[2]],
        pos: u,
        rot: [0, 0, 0],
        anchor: [0.5, 0, 1]
      }, []);
      t.children.push(v);
    }
  }
}
function U(n) {
  n = A(n);
  const l = n.distance(), a = n.delta(new r()).normalize(), c = Math.floor(l / (F + 0.5 * M));
  if (c <= 1) {
    const s = A(n).getCenter(new r());
    return [new x(
      s.clone().add(a.clone().multiplyScalar(-E / 2)),
      s.clone().add(a.clone().multiplyScalar(E / 2))
    )];
  }
  const p = c - 1, L = (l - M * p) / c;
  let m = n.start;
  const w = [];
  for (let s = 0; s < c; s++) {
    const e = m.add(a.clone().multiplyScalar(L)), o = new x(m, e);
    w.push(o), m = e.clone().add(a.clone().multiplyScalar(M));
  }
  return w;
}
export {
  pe as createPodiumGlazing
};
//# sourceMappingURL=index2.js.map
